import * as msTeams from "@microsoft/teams-js";
import React, { createContext, useEffect, useState } from "react";

export interface MsTeamsContextProps {
    isInitialized: boolean;
    isAppInsideMsTeams: boolean;
    currentMsTeamsThemeName: string;
    teamsClientType: msTeams.HostClientType;
    isMobileClient: boolean;
    userObjectId?: string;
    userPrincipalName: string | undefined;
}

export const defaultMsTeamsContextProps: MsTeamsContextProps = {
    isInitialized: false,
    isAppInsideMsTeams: false,
    currentMsTeamsThemeName: "default",
    teamsClientType: msTeams.HostClientType.desktop,
    isMobileClient: false,
    userObjectId: undefined,
    userPrincipalName: undefined,
};

export const MsTeamsContext = createContext(defaultMsTeamsContextProps);

const MsTeamsStore: React.FC = (props) => {
    const [isInitialized, setIsInitialized] = useState(false);
    const [isAppInsideMsTeams, setIsAppInsideMsTeams] = useState(false);
    const [currentMsTeamsThemeName, setCurrentMsTeamsThemeName] = useState("default");
    const [teamsClientType, setTeamsClientType] = useState<msTeams.HostClientType>(msTeams.HostClientType.desktop);
    const [userObjectId, setUserObjectId] = useState<string | undefined>();
    const [isMobileClient, setIsMobileClient] = useState(false);
    const [userPrincipalName, setUserPrincipalName] = useState<string | undefined>();

    useEffect(() => {
        if (process.env.REACT_APP_USE_WITH_NO_TEAMS === "true") {
            setIsInitialized(true);
            return;
        }

        const initialize = async () => {
            await msTeams.app.initialize();
            setIsAppInsideMsTeams(true);
            const msTeamsContext = await msTeams.app.getContext();
            setCurrentMsTeamsThemeName(msTeamsContext.app.theme);
            const clientType = msTeamsContext.app.host.clientType;
            setTeamsClientType(clientType);
            setIsMobileClient(
                clientType === msTeams.HostClientType.android ||
                clientType === msTeams.HostClientType.ios
            );

            setUserObjectId(msTeamsContext.user?.id);
            setUserPrincipalName(msTeamsContext.user?.userPrincipalName);

            msTeams.app.registerOnThemeChangeHandler((theme) => {
                setCurrentMsTeamsThemeName(theme);
            });

            msTeams.app.notifySuccess();
            setIsInitialized(true);
        }

        initialize();

    }, []);

    if (!isInitialized) {
        return null;
    }

    return (
        <MsTeamsContext.Provider
            value={{
                isInitialized: isInitialized,
                isAppInsideMsTeams: isAppInsideMsTeams,
                currentMsTeamsThemeName: currentMsTeamsThemeName,
                teamsClientType: teamsClientType,
                isMobileClient: isMobileClient,
                userObjectId: userObjectId,
                userPrincipalName: userPrincipalName,
            }}
        >
            {props.children}
        </MsTeamsContext.Provider>
    );
};

export default MsTeamsStore;
